export default {"src":"/_next/static/media/location.d1f539a8.svg","height":20,"width":20};